module.exports = __webpack_public_path__ + "static/media/wine-glass.33ad1fce.svg";